import { reducerWithInitialState } from "typescript-fsa-reducers";
import { ScreenSize } from "../utils/media";
import { screenSizeChanged } from "../actions/Media";

export interface MediaState {
  screenSize: ScreenSize;
}

const initialState: MediaState = {
  screenSize: "small",
};

const mediaReducer = reducerWithInitialState(initialState).case(screenSizeChanged, (state, screenSize) => {
  return { ...state, screenSize };
});

export default mediaReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/media.ts